import React from 'react';

function PainPointsSection() {
    const painPoints = [
        {
            icon: '💸',
            title: 'OTA Commission Bleeding',
            items: [
                { marker: '📍', text: 'You\'re on 8 OTAs with 8 different rates and 47 unanswered reviews' },
                { marker: '📍', text: 'This is why Booking.com ranks your competitor first' },
                { marker: '📍', text: '60-70% of bookings through OTAs at 15-25% commission each' },
                { marker: '📍', text: 'You\'re paying Booking.com more than your entire housekeeping department' },
                { marker: '💰', text: 'Average Loss: $120K-$400K annually', strong: true }
            ]
        },
        {
            icon: '🔄',
            title: 'The Turnover Nightmare',
            items: [
                { marker: '📍', text: 'New front desk clerks quit after their first day' },
                { marker: '📍', text: 'Schedule changes announced 1 hour into shifts' },
                { marker: '📍', text: 'No systems = new hires thrown into chaos' },
                { marker: '📍', text: 'You\'re spending $200K+ annually hiring people who quit in 3 months' },
                { marker: '💰', text: 'Industry Average: 73% turnover | Crisis Properties: 180%', strong: true }
            ]
        },
        {
            icon: '⭐',
            title: 'Review Terrorism',
            items: [
                { marker: '📍', text: 'One bad review stops 30 bookings dead' },
                { marker: '📍', text: 'Just a couple dissatisfied customers sharing online can put you out of business' },
                { marker: '📍', text: 'Guests use reviews as weapons to get refunds and freebies' },
                { marker: '📍', text: '4.0 rating = 15% conversion | 4.5 rating = 28% conversion' },
                { marker: '💰', text: 'One star increase = 5-9% revenue jump', strong: true }
            ]
        },
        {
            icon: '📅',
            title: 'Empty Weekdays, Slammed Weekends',
            items: [
                { marker: '📍', text: '85% occupancy weekends, 35% weekdays' },
                { marker: '📍', text: 'Without corporate business, rates would be rock bottom during the week' },
                { marker: '📍', text: 'Hotels would be empty Monday-Thursday without these guests' },
                { marker: '📍', text: 'Massive revenue potential sitting untapped' },
                { marker: '💰', text: 'Lost Opportunity: $340K+ annually', strong: true }
            ]
        },
        {
            icon: '🏨',
            title: 'The 10:30 PM Audit',
            items: [
                { marker: '📍', text: '12 managers crammed in a room after 12 hours' },
                { marker: '📍', text: 'Executive Housekeeper front and center reading scores' },
                { marker: '📍', text: 'Room looks clean but scored 60th percentile' },
                { marker: '📍', text: 'Your GM\'s future depends on these audit scores' },
                { marker: '💰', text: 'Most visible department failure = Career killer', strong: true }
            ]
        },
        {
            icon: '📱',
            title: 'Your GM\'s Phone Never Stops',
            items: [
                { marker: '📍', text: 'Called at the hospital with a newborn to write guest commentary' },
                { marker: '📍', text: 'On call 24/7. Expected to work 10-12 hour days "just in case"' },
                { marker: '📍', text: 'Work weekends, holidays, Christmas, New Year' },
                { marker: '📍', text: 'Missing family events becomes the norm' },
                { marker: '💰', text: 'Work-life balance? "Utter bullshit in your 40s"', strong: true }
            ]
        }
    ];

    return (
        <section className="chaos-section">
            <div className="section-content">
                <h2 className="section-title">We Know What Keeps You Up at <span className="highlight">10:30 PM</span></h2>
                <p className="section-subtitle">
                    After working with 200+ properties, we've seen these problems destroy good hotels. Every. Single. Time.
                </p>
                <div className="comparison-grid">
                    {painPoints.map((point, index) => (
                        <div key={index} className="comparison-card">
                            <div className="comparison-icon">{point.icon}</div>
                            <h3 className="comparison-title">{point.title}</h3>
                            <ul className="comparison-list">
                                {point.items.map((item, itemIndex) => (
                                    <li key={itemIndex}>
                                        <span>{item.marker}</span>
                                        {item.strong ? <strong>{item.text}</strong> : <span>{item.text}</span>}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PainPointsSection;

